import { ListItem, UnorderedList } from '@chakra-ui/react';
import { LinkText, Paragraph } from '../common/Typography';

const ReturnDisclosurePortfolio = () => (
    <>
        <Paragraph fontWeight="bold">
            Interactive Educational Analysis Tools using Hypothetical
            Performance for Financial Planning
        </Paragraph>
        <Paragraph>
            Plenty Financial intends to accelerate clients’ reaching discrete
            financial goals. Plenty Financial’s platform is not intended to
            provide comprehensive investment advice for every aspect of a
            client’s financial situation and does not incorporate investments
            that clients hold elsewhere. Additionally, Plenty Financial’s
            platform does not pro actively assess and understand information
            that a client may not have disclosed. As a result, any suggested
            tips or educational tooling cannot guarantee the completeness of
            information used.
        </Paragraph>
        <Paragraph>
            Plenty Financial provides educational tools for financial planning;
            these are intended to be for illustrative purposes. Information
            provided are “forward-looking” details that are inherently
            unreliable and actual events or results may differ materially from
            those reflected here. Plenty Financial does not make any assurance
            or guarantees as to the accuracy of any estimates or calculations
            provided by the educational tools. Plenty Financial uses client or
            third party information for forward-looking calculations but cannot
            guarantee the accuracy and completeness of information provided by
            clients or third parties. Plenty Financial does not provide tax
            advice and recommends that individuals consult with additional tax
            advisors.
        </Paragraph>
        <Paragraph>
            Our interactive tools are not a recommendation for any security or
            investment. References to any investments are intended to illustrate
            the application of the investment process only and should not be
            used as the basis for making any decision about purchasing, holding
            or selling any securities. A sample portfolio is used in the tool
            but completing an actual investment requires a client to select and
            confirm a model portfolio that may differ from the portfolio shown
            in the interactive tool. This Interactive Analysis Tool contains
            inherent limitations and is not a substitute for actual investment
            returns derived from a live portfolio.
        </Paragraph>
        <Paragraph>
            Return data used in the interactive tool are hypothetical
            performance data which contains inherent limitations and is not a
            substitute for actual investment returns derived from a live
            portfolio. There are numerous risk factors related to trading and
            markets which cannot be fully accounted for when depicting
            Hypothetical Performance. Consequently, future returns are not
            guaranteed, and a loss of principal may occur.
        </Paragraph>
        <Paragraph>
            The Tool depicted assumes the following:
            <UnorderedList>
                <ListItem>A steady contribution rate (set by you)</ListItem>
                <ListItem>
                    an annual rate of return of x% per year (based on a risk
                    level you select)
                </ListItem>
                <ListItem>
                    Including a reinvestment of interest and dividends
                </ListItem>
                <ListItem>
                    Excluding taxes, transaction fees, management fees, and
                    other factors which might impact results
                </ListItem>
            </UnorderedList>
        </Paragraph>
        <Paragraph>
            Further, any investing strategy involves legal, regulatory,
            macroeconomic, liquidity and other risks which could negatively
            impact returns. Similarly, operational risk, such as business
            continuity risk could negatively affect investment results. Further,
            opportunity risk exists insofar as other investments may have
            similar or superior characteristics.
        </Paragraph>
        <Paragraph>
            The annual return rates that we use for various portfolio
            compositions are based on{' '}
            <LinkText
                target="_blank"
                href="https://www.invesco.com/content/dam/invesco/apac/en/pdf/insights/2023/december/LTCMA-USD-Dec-2023.pdf"
            >
                LTCMA-USD-Dec-2023.pdf (invesco.com)
            </LinkText>{' '}
            produced by Invesco. Specifically, the expected returns for MSCI
            ACWI (for equities) 7.30% and the BBG US Aggregate Bond Index (for
            fixed income) 5.30% is used to calculate the annual return rates.
            Source: Invesco, estimates as of September 30, 2023. These estimates
            are forward-looking, are not guarantees, and they involve risks,
            uncertainties, and assumptions. The analysis is based on historical
            returns; past performance does not guarantee future results. The
            Analysis includes dividends and interest, but excludes taxes,
            transaction fees, management fees, and other factors which would
            impact results. Results assume rebalancing on the last trading day
            of each quarter and immediate reinvestment of dividends. Given that
            use of the two broad based indexes this results in a limitation that
            the analysis does not account for all indexes, customizations, and
            securities that may be reflected in a portfolio. For Plenty’s
            general disclosures,{' '}
            <LinkText
                target="_blank"
                href="https://www.withplenty.com/legal#generaldisclosures"
            >
                please see here
            </LinkText>
            .
        </Paragraph>
    </>
);

export default ReturnDisclosurePortfolio;
